import { useState } from "react";
import { Loader2 } from "lucide-react";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** Mobile-friendly stage picker (no drag-and-drop on mobile). */
export const ChangeStageDialog = ({ open, onOpenChange, lead, stages, onChange }) => {
  const [target, setTarget] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!target) return;
    setSaving(true);
    try {
      await onChange(lead.id, target);
      onOpenChange(false);
      setTarget("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-stage-dialog">
        <DialogHeader>
          <DialogTitle>Change stage</DialogTitle>
          <DialogDescription>
            Move {lead?.contact?.first_name} {lead?.contact?.last_name} to a new pipeline stage.
          </DialogDescription>
        </DialogHeader>
        <Select value={target || lead?.pipeline_stage_id} onValueChange={setTarget}>
          <SelectTrigger data-testid="change-stage-select"><SelectValue placeholder="Select stage…" /></SelectTrigger>
          <SelectContent>
            {stages.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="change-stage-cancel">Cancel</Button>
          <Button onClick={submit} disabled={saving || !target} data-testid="change-stage-save">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Move"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
